export default __webpack_public_path__ + "static/media/notFound.8b430de9.jpg";